import React, { useState, useEffect } from 'react';
import AuthContext from './AuthContext';

const AuthContextProvider = ({ children }) => {
  const [loginDetails, setLoginDetails] = useState({
    isAuthenticated: !!localStorage.getItem('admin_token')
  });

  // Sync state with local storage when token changes
  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    setLoginDetails({ isAuthenticated: !!token });
  }, []);

  return <AuthContext.Provider value={{ loginDetails, setLoginDetails }}>{children}</AuthContext.Provider>;
};

export default AuthContextProvider;
